import MonthlyCommonDashboard from "../MonthlyCommonDashboard/MonthlyCommonDashboard";
import { GetSettledMemberRegisterReport } from "../../../../Helpers/APIEndPoints/EndPoints";

const SettledMemberRegister = () => {
  return (
    <>
      <MonthlyCommonDashboard
        PageName="SettledMemberRegister"
        ExportToExcelUrl={GetSettledMemberRegisterReport}
        UploadExcel={false} // true -> Option for UploadExcel, false -> NO Option for UploadExcel
        ExcelImport={""}
        openModal={""}
      />
    </>
  );
};

export default SettledMemberRegister;
